export * as fsFunctionType from './function-type'
